<template>
    <ContentComp>
        <AlertMessage
            type="info"
            class="mb-3"
        >
            <div v-html="$tm('stationrole.trackinginfo', '', true)"></div>
        </AlertMessage>

        <FormLayout
            v-if="model != null"
            :label-width="250"
        >
            <FormLayoutRow>
                <FormLayoutLabel text="stationrole.gpscreatepassradius"></FormLayoutLabel>
                <div class="w-25">
                    <InputNullableInt
                        v-model="model!.GPSCreatePassRadius"
                        icon=""
                        posttext="m"
                        placeholder="0"
                        :handleZeroDigitAsNull="true"
                    />
                </div>
            </FormLayoutRow>
        </FormLayout>
    </ContentComp>
</template>
<script lang="ts" setup>
import { AlertMessage, InputNullableInt } from '@/components';
import { FormLayout, FormLayoutLabel, FormLayoutRow } from '@/components/Form';
import ContentComp from '@/components/layout/ContentComp.vue';
import { StationRole } from '@/objects/generated';

const model = defineModel<StationRole | null>({ required: true });
</script>
